import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactModal from 'react-modal';

const ModalWrapper = ({
  className = 'Modal_Portal',
  overlayClassName = 'Modal_Overlay',
  modalClassName = 'Modal',
  onClose,
  ...props
}) => (
  <ReactModal
    overlayClassName={overlayClassName}
    portalClassName={className}
    className={modalClassName}
    onRequestClose={onClose}
    {...props}
  />
);
ModalWrapper.propTypes = {
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  modalClassName: PropTypes.string,
  onClose: PropTypes.func.isRequired
};
export const BaseModal = styled(ModalWrapper)`
  .Modal_Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .Modal {
    ${(props) => props.theme.type.modal};

    padding: 30px;
    @media (max-width: 400px) {
      max-width: 80vw;
    }
  }
`;
BaseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
export default BaseModal;
